import React, { useState } from 'react'

import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useQuery } from 'src/hooks'
import authService from '../../services/auth.service'
import LoadingIndicator from 'src/common/components/LoadingIndicator'
import Spacer from 'src/common/components/Spacer'
import Logo from 'src/common/logo'

const VantaRedirectPage = () => {
  const [loading, setLoading] = useState(false)

  const query = useQuery()
  const navigate = useNavigate()

  useEffect(() => {
    setLoading(true)
    authService
      .authorizeVanta(query.get('code'))
      .then(() => {
        setLoading(false)
        navigate('/settings/compliance?continueConfig=true&selectedConnector=VANTA')
      })
      .catch(err => {
        console.error(err)
        navigate(
          '/settings/compliance?errorSync=' + err.response.data.description ||
            'Something went wrong' + '&errorSyncType=VANTA'
        )
        setLoading(false)
      })
  }, [])

  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        background: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: '20px'
      }}
    >
      <Logo />
      <Spacer />
      {loading && <LoadingIndicator />}
      <Spacer />
    </div>
  )
}

export default VantaRedirectPage
